import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "rowHeight", "rowBorderHeight", "tableHeaderHeight", "overScanRowCount", "virtualizedScrollElem", "style"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Children, Component } from 'react';
import { ReactTableDefaults } from 'react-table';
import { List, AutoSizer, WindowScroller } from 'react-virtualized';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import TableRow from './TableRow';
import styles from '../../table.module.scss';
function withVirtualizedTable(WrappedComponent) {
  var WithVirtualizedTable = /*#__PURE__*/function (_Component) {
    _inherits(WithVirtualizedTable, _Component);
    var _super = _createSuper(WithVirtualizedTable);
    function WithVirtualizedTable(_props) {
      var _this;
      _classCallCheck(this, WithVirtualizedTable);
      _this = _super.call(this, _props);
      _defineProperty(_assertThisInitialized(_this), "createTableRows", defaultMemoize(function (rows) {
        return rows.forEach(function (item, index) {
          _this.tableRows[index] = function (currentProps) {
            return /*#__PURE__*/React.createElement("div", {
              style: currentProps.style
            }, /*#__PURE__*/React.createElement(TableRow, {
              row: item
            }));
          };
        });
      }));
      _defineProperty(_assertThisInitialized(_this), "getVirtualizedProps", defaultMemoize(function (useVirtualized) {
        if (!useVirtualized) {
          return EMPTY_OBJECT;
        }
        return {
          getTbodyProps: _this.getTbodyProps,
          TbodyComponent: _this.TbodyComponent
        };
      }));
      _defineProperty(_assertThisInitialized(_this), "rowRenderer", function (_ref) {
        var key = _ref.key,
          index = _ref.index,
          style = _ref.style;
        var RowComponent = _this.tableRows[index];
        return /*#__PURE__*/React.createElement(RowComponent, {
          key: key,
          style: style
        });
      });
      _defineProperty(_assertThisInitialized(_this), "TbodyComponent", function (props) {
        var children = props.children,
          rowHeight = props.rowHeight,
          rowBorderHeight = props.rowBorderHeight,
          tableHeaderHeight = props.tableHeaderHeight,
          overScanRowCount = props.overScanRowCount,
          virtualizedScrollElem = props.virtualizedScrollElem,
          style = props.style,
          restProps = _objectWithoutProperties(props, _excluded);
        var rows = Children.toArray(children);
        _this.createTableRows(rows);
        if (!_this.scrollElement) {
          _this.scrollElement = document.querySelector(virtualizedScrollElem);
        }
        if (_this.listComponent.current) {
          _this.listComponent.current.forceUpdateGrid();
        }
        return /*#__PURE__*/React.createElement(ReactTableDefaults.TbodyComponent, _extends({}, restProps, {
          className: styles.virtualizedBodyComponent
        }), /*#__PURE__*/React.createElement(WindowScroller, {
          scrollElement: _this.scrollElement || window
        }, function (_ref2) {
          var height = _ref2.height,
            onChildScroll = _ref2.onChildScroll,
            scrollTop = _ref2.scrollTop;
          return /*#__PURE__*/React.createElement(AutoSizer, {
            disableHeight: true
          }, function (_ref3) {
            var width = _ref3.width;
            return /*#__PURE__*/React.createElement(List, {
              autoHeight: true,
              width: width,
              height: height - tableHeaderHeight,
              rowCount: rows.length,
              rowHeight: rowHeight + rowBorderHeight,
              rowRenderer: _this.rowRenderer,
              onScroll: onChildScroll,
              scrollTop: scrollTop,
              overscanRowCount: overScanRowCount,
              ref: _this.listComponent
            });
          });
        }));
      });
      _defineProperty(_assertThisInitialized(_this), "getTbodyProps", function (state) {
        return state;
      });
      _this.tableRows = {};
      _this.listComponent = /*#__PURE__*/React.createRef();
      return _this;
    }
    _createClass(WithVirtualizedTable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var virtualizedScrollElem = this.props.virtualizedScrollElem;
        this.scrollElement = document.querySelector(virtualizedScrollElem);
      }
    }, {
      key: "render",
      value: function render() {
        var useVirtualized = this.props.useVirtualized;
        var virtualizedProps = this.getVirtualizedProps(useVirtualized);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, virtualizedProps));
      }
    }]);
    return WithVirtualizedTable;
  }(Component);
  WithVirtualizedTable.propTypes = {
    useVirtualized: PropTypes.bool,
    rowBorderHeight: PropTypes.number,
    tableHeaderHeight: PropTypes.number,
    overScanRowCount: PropTypes.number,
    virtualizedScrollElem: PropTypes.string
  };
  WithVirtualizedTable.defaultProps = {
    useVirtualized: false,
    rowBorderHeight: 1,
    tableHeaderHeight: 40,
    overScanRowCount: 10,
    virtualizedScrollElem: '.rt-table'
  };
  return WithVirtualizedTable;
}
export default withVirtualizedTable;